import React from 'react';
import RoleUtils from '../../../src/util/RoleUtils'; 
import {PERMISSIONS, PERMISSIONS_NEW} from '../../../src/util/constants'; 

const Button = ({ addButtonCallback, butttonText,icon }) => {
  return (
    RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENTITIES.MANAGE_SHIPPER_CONSIGNEE) && (
      <p className="level-item">
        <button
          className="button"
           style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
          onClick={addButtonCallback}
        > {icon}
          {butttonText}
        </button>
      </p>
    )
  );
};

export default Button;
